/**
 * Returns the default view scale for the passed layer
 */
function getDefaultScale(layer) {
    let scale;
    switch (layer){
        case "osmm":
            scale = 500; 
            break;
        case "osmmbw":
            scale = 500; 
            break;
        case "os25k":
            scale = 17500; 
            break;
        case "os50k":
            scale = 35000;  
            break;
        case "os250k":
            scale = 100000; 
            break;
        case "aerial":
            scale = 3000; 
            break;
        default:
        case "os10k":
            scale = 7500; 
            break;

    }
    return scale;
}

export default getDefaultScale;